
// import { createContext, useContext, useState } from "react";
// import LoginModal from "../pages/Login/login";
// import SignupModal from '../pages/SignUp/Signup';


// const ModalContext = createContext();

// export const ModalProvider = ({ children }) => {
//   const [showLogin, setShowLogin] = useState(false);
//   const [showSignup, setShowSignup] = useState(false);


//   // const requireLoginn = () => showLogin(true);
//   const closeLogin = () => showLogin(false);

//   const [isLoggedIn, setIsLoggedIn] = useState(
//     !!localStorage.getItem("authToken")
//   );

//   // global login checker
//   const requireLogin = (callback) => {
//     if (localStorage.getItem("authToken")) {

//       setShowLogin(true);
//       return;
//     }
//     callback();
//   };


//   return (
//     <ModalContext.Provider value={{
//       showLogin, setShowLogin, showSignup, setShowSignup, closeLogin, isLoggedIn,
//       setIsLoggedIn,
//       requireLogin,
//     }}>
//       {children}
//       <LoginModal open={showLogin} handleClose={() => setShowLogin(false)} />
//       <SignupModal open={showSignup} handleClose={() => setShowSignup(false)} />
//     </ModalContext.Provider>
//   );
// };

// export const useModal = () => useContext(ModalContext);
import { createContext, useContext, useState } from "react";
import LoginModal from "../pages/Login/login";
import SignupModal from "../pages/SignUp/Signup";
import VerifyStatusDialog from "../pages/profile/MenuPages/VerifyStatusDialog.jsx";
import ReferralModal from "../components/common/ReferralModal";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showReferral, setShowReferral] = useState(false);
  //VERIFY MODAL STATE
  const [showVerify, setShowVerify] = useState(false);
  const [verifyData, setVerifyData] = useState(null);
  const openVerify = (data) => {
    setVerifyData(data);
    setShowVerify(true);
  };

  const closeVerify = () => {
    setShowVerify(false);
    setVerifyData(null);
  };
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("authToken")
  );

  // CORRECT requireLogin
  const requireLogin = (callback) => {
    if (!localStorage.getItem("authToken")) {
      // NOT logged in → show login

      setShowLogin(true);
      return;
    }

    // Logged in → run protected action

    callback();
  };

  return (
    <ModalContext.Provider
      value={{
        showLogin,
        setShowLogin,
        showSignup,
        setShowSignup,
        isLoggedIn,
        setIsLoggedIn,
        requireLogin,
        openVerify,
        closeVerify,
        showReferral,
        setShowReferral,
      }}
    >
      {children}

      {/* global modals */}
      <LoginModal open={showLogin} handleClose={() => setShowLogin(false)} />
      <SignupModal open={showSignup} handleClose={() => setShowSignup(false)} />
      {/*GLOBAL VERIFY MODAL */}
      <VerifyStatusDialog open={showVerify} onClose={closeVerify} data={verifyData} />
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
